import { InteractionLoading } from '@workwave-tidal/lab/Conversation'

export function LoadingComponent(props: { alignment: 'left' | 'right' }) {
  const { alignment } = props

  return (
    <InteractionLoading
      sx={{
        justifyContent: alignment === 'right' ? 'flex-end' : 'flex-start',
        margin: 2,
      }}
    />
  )
}
